import React, { Suspense } from 'react';
import LoadingSpinner from './LoadingSpinner';

/**
 * Suspense wrapper for lazy-loaded components
 * @param {Object} props
 * @param {React.Component} props.children - Lazy loaded component
 * @param {string} props.fallbackMessage - Loading message
 */
const PageSuspense = ({ children, fallbackMessage = "Loading..." }) => {
  const LoadingFallback = () => (
    <LoadingSpinner message={fallbackMessage} size="medium" />
  );

  return (
    <Suspense fallback={<LoadingFallback />}>
      {children}
    </Suspense>
  );
};

export default PageSuspense;